import { DecisionButton } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/BankAccountDetails/components/DecisionButton.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme.ts';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { BankAccountReviewAction } from '@dealstack/shared/lib/generated';
import { Flex } from '@mantine/core';

interface Props {
	disabled: boolean;
	onReview: (action: BankAccountReviewAction) => void;
}

export const ReviewActions = ({ disabled, onReview }: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<Flex gap="1rem" px="1rem" pb="1rem" align="stretch">
			<DecisionButton
				label={tMipManage('bank_accounts.review.approve')}
				iconVariant="checkmark"
				color={defaultTheme.v3.colors.dark[8]}
				backgroundColor={defaultTheme.v3.colors.gray[0]}
				borderColor={defaultTheme.v3.colors.gray[2]}
				disabled={disabled}
				dataTestId={TEST_ELEMENT_IDS.MIP_MANAGE_BANK_ACCOUNT_APPROVE_BUTTON}
				onClick={() => onReview(BankAccountReviewAction.APPROVE)}
			/>
			<DecisionButton
				label={tMipManage('bank_accounts.review.decline')}
				iconVariant="close-v3"
				color={defaultTheme.v3.colors.red[6]}
				backgroundColor={defaultTheme.v3.colors.red[0]}
				borderColor={defaultTheme.v3.colors.red[4]}
				disabled={disabled}
				dataTestId={TEST_ELEMENT_IDS.MIP_MANAGE_BANK_ACCOUNT_DECLINE_BUTTON}
				onClick={() => onReview(BankAccountReviewAction.DECLINE)}
			/>
		</Flex>
	);
};
